var exports = {
  "M": "showLabel__njFTZE",
  "D": "showItem__8fthEB",
};

module.exports = exports;
